module.exports = __webpack_public_path__ + "static/img/arrow-point-to-right.29220e41.svg";